import { getClient } from '@zg-rentals/ts-client-http-client';

export const rentalManagerClient = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_MANAGER_PREFIX_URL });

export const rentalClient = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX_URL });
